import moment from "moment-timezone";
/** Format the pickup date to the specified format
 * @param {string} pickupDate - The pickup date to format
 * @param {string} formatDate - The desired date format
 * @returns {string} - The formatted pickup date
 */
export function formatPickupDate(pickupDate, formatDate) {
    return moment(pickupDate).utc(true).format(formatDate);
}

/** Format the pickup time to the specified format
 * @param {string} pickupTime - The pickup time to format
 * @param {string} formatTime - The desired time format
 * @returns {string} - The formatted pickup time
 */
export function formatPickupTime(pickupTime, formatTime) {
    return moment(pickupTime, ["hh:mm A"]).format(formatTime);
}

/** Format the vehicle category to a more user-friendly string
 * @param {string} category - The vehicle category to format
 * @returns {string} - The formatted vehicle category
 */
export function formatVehicleCategory(category) {
    if (category === "standard") {
        return "Standard Class";
    } else if (category === "business") {
        return "Business Class";
    } else {
        return "Luxury Class";
    }
}

/** Format the passenger type to a more user-friendly string
 * @param {string} type - The passenger type to format
 * @returns {string} - The formatted passenger type
 */
export function formatBookingType(type) {
    if (type === "airport") {
        return "Airport Transfer";
    } else if (type === "arrival") {
        return "Airport Transfer (Arrival)";
    } else if (type === "departure") {
        return "Airport Transfer (Departure)";
    } else if (type === "station") {
        return "Station Transfer";
    } else if (type === "port") {
        return "Port Transfer";
    } else if (type === "hourly") {
        return "Hourly";
    } else if (type === "journey") {
        return "Journey";
    }
}

/** Format the payment type to a more user-friendly string
 * @param {string} type - The payment type to format
 * @returns {string} - The formatted payment type
 */
export function formatPaymentType(type) {
    if (type === "ota") {
        return "OTA";
    } else if (type === "card") {
        return "Credit Card";
    } else if (type === "transfer") {
        return "Bank Transfer";
    } else if (type === "paypal") {
        return "PayPal";
    }
}
